import React from "react";
import Loading from "app/components/Loading";

const Suspense = ({ children }) => {
  return <React.Suspense fallback={<Loading />}>{children}</React.Suspense>;
};

export default Suspense;
